export const getLoggedStatus = () =>
  localStorage.getItem("loggedIn") === "true";

export const getLoggedUser = () => {
  const user = localStorage.getItem("loggedUser");
  return user ? JSON.parse(user) : null;
};

export const getStoredToken = () => localStorage.getItem("token");
export const removeLoggedStatus = () => localStorage.removeItem("loggedIn");
export const removeLoggedUser = () => localStorage.removeItem("loggedUser");
export const removeToken = () => localStorage.removeItem("token");
export const storeLoggedStatus = (status: any) =>
  localStorage.setItem("loggedIn", status);
export const storeLoggedUser = (user: any) =>
  localStorage.setItem("loggedUser", user);
export const storeToken = (token: string) =>
  localStorage.setItem("token", token);
